module.exports = __webpack_public_path__ + "static/media/arrows-maximize.a05be2ea.svg";